module.exports = __webpack_public_path__ + "app/bento-components/blog-river/media/icon.svg?e1942cd4ade6037fd4e4e11de48a80bc";